import type { CSSProperties } from 'react';

/** Inline style with CSS custom properties, e.g. vars({ '--mod': 'var(--c-gitar)' }). */
export const vars = (v: Record<`--${string}`, string>, extra: CSSProperties = {}): CSSProperties =>
  ({ ...v, ...extra }) as CSSProperties;

/** Section accent colour for a module page. */
export const modStyle = (module: string, extra: CSSProperties = {}): CSSProperties =>
  vars({ '--mod': `var(--c-${module})` }, extra);
